import React from 'react'

const DatePicker = ({
  placeholderValue,
  labelValue,
  selected,
  onChange,
  minDate,
  maxDate,
  disable,
}) => {
  return (
    <div className="flex gap-1 w-full max-w-96 flex-col text-start">
      <label className="text-stone-700 text-xs md:text-base font-semibold mt-2">
        {labelValue}
      </label>
      <div>
        <input
          type="date"
          className="border-b text-sm border-gray-300 text-gray-900 md:text-base  focus:border-b focus:border-blue-500 block w-full pb-1 pt-1 outline-none"
          placeholder={placeholderValue || 'Select date'}
          value={
            selected ? new Date(selected)?.toISOString()?.substr(0, 10) : ''
          }
          onChange={(e) =>
            onChange(e.target.value ? new Date(e.target.value) : null)
          }
          disabled={disable}
          min={minDate && minDate}
          max={maxDate && maxDate}
        />
      </div>
    </div>
  )
}

export default DatePicker
